import React from 'react'

const Footer = () => {
    return (
        <footer className="bg-[#282828] border-t border-[#545454]" style={{ zIndex: 50, bottom: 0, width: '100%' }}>
            <div className="w-full p-2 text-center">
                <span className="text-sm text-[#B0B0B0] sm:text-center">Copyright © 2025 PG.com. All rights reserved.
                </span>
            </div>
        </footer>
    )
}

export default Footer
